var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DropdownMenu',{attrs:{"name":"Access"}},[_c('DropdownMenuItem',{attrs:{"name":"Free","value":"free:true"}}),_vm._v(" "),_c('DropdownMenuItem',{attrs:{"name":"Premium","value":"free:false"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }